// TODO: css 조각을 편하면서도 type-safe 하게 사용할 수 있는 방법 찾기
// 이렇게 쓰면 편한데 type-safe 하지 않음
// [typed-css-module](https://www.npmjs.com/package/typed-css-modules) 라이브러리 적용해보기ㄴ
export { default as utilStyles } from './utils.module.css';
